import React, { useEffect, useState } from "react";
import { jsPDF } from "jspdf";
import { FaFileInvoiceDollar } from "react-icons/fa";
import Gnavbar from "../components/Gnavbar";
import { getRequest } from "../helpers/api.helper";

const MemberShipDetail: React.FC = () => {
  const [invoiceData, setInvoiceData] = useState<any>(null);

  const fetchData = async () => {
    const response = await getRequest("/bureau/me");
    if (response?.success) {
      const profile = response.data.profile;
      const pack = response.data.packageInfo;

      setInvoiceData({
        bureauName: profile.bureauName,
        bureauId: profile.bureauId,
        joinDate: pack ? new Date(pack.assignedAt).toLocaleDateString() : null,
        expiryDate: pack
          ? new Date(pack.expiryDate).toLocaleDateString()
          : null,
        planName: pack ? pack.title : null,
        amountPaid: pack ? pack.amount : null,
        paymentStatus: profile.paymentStatus,
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const generateInvoicePDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("INVOICE", 105, 20, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    const lineY = 30;
    doc.line(20, lineY, 190, lineY); // horizontal line

    let y = 45;
    const gap = 10;

    const writeLine = (label: string, value: string | number) => {
      doc.setFont("helvetica", "bold");
      doc.text(`${label}:`, 25, y);
      doc.setFont("helvetica", "normal");
      doc.text(`${value}`, 80, y);
      y += gap;
    };

    writeLine("Bureau Name", invoiceData.bureauName);
    writeLine("Bureau ID", invoiceData.bureauId);
    if (invoiceData.joinDate) writeLine("Joining Date", invoiceData.joinDate);
    if (invoiceData.joinDate) writeLine("Plan", invoiceData.planName);
    if (invoiceData.joinDate)
      writeLine("Amount Paid", `₹${invoiceData.amountPaid}`);

    doc.setFont("helvetica", "bold");
    doc.text(`Total: ₹${invoiceData.amountPaid}`, 25, y + 10);

    doc.line(20, y + 15, 190, y + 15);
    doc.setFontSize(10);
    doc.text(
      "This is a computer-generated invoice.",
      105,
      y + 25,
      { align: "center" }
    );

    doc.save(`${invoiceData.bureauId}_invoice.pdf`);
  };

  if (!invoiceData) {
    return (
      <>
        <Gnavbar />
        <div className="p-8 text-center text-gray-600">Loading...</div>
      </>
    );
  }

  return (
    <>
      {/* Global Navbar */}
      <Gnavbar />

      {/* Main Content */}
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-start pt-10 pb-10 px-4">
        <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-md border border-gray-200">
          <h1 className="text-2xl font-bold text-center mb-4 text-purple-700">
            Membership Invoice
          </h1>

          <div className="space-y-2 text-gray-700 text-sm">
            <p>
              <strong>Account:</strong>{" "}
              {invoiceData.paymentStatus == 0 ? "Free Account" : "Paid Account"}
            </p>
            <p>
              <strong>Bureau Name:</strong> {invoiceData.bureauName}
            </p>
            <p>
              <strong>Bureau ID:</strong> {invoiceData.bureauId}
            </p>
            {invoiceData.joinDate && (
              <p>
                <strong>Joining Date:</strong> {invoiceData.joinDate}
              </p>
            )}
            {invoiceData.expiryDate && (
              <p>
                <strong>Expiry Date:</strong> {invoiceData.expiryDate}
              </p>
            )}
            {invoiceData.planName && (
              <p>
                <strong>Plan Name:</strong> {invoiceData.planName}
              </p>
            )}
            {invoiceData.amountPaid && (
              <p>
                <strong>Amount Paid:</strong> ₹{invoiceData.amountPaid}
              </p>
            )}
          </div>

          <button
            onClick={generateInvoicePDF}
            className="mt-6 w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2 hover:scale-[1.02] transition"
          >
            <FaFileInvoiceDollar size={20} />
            Download Invoice
          </button>
        </div>
      </div>
    </>
  );
};

export default MemberShipDetail;
